import '../styles/google-signin.css';
import { useState } from 'react';
import firebase, { auth } from './firebase';

/* Вход с Google през изскачащ прозорец. Пренасочването (signInWithRedirect)
   не става: authDomain е hand-drawn-wear.firebaseapp.com, а сайтът е на
   stamsyart.bg, и браузърите вече не пускат бисквитките на чуждия домейн.

   Google не допуска вход във вградените браузъри на приложенията (Facebook,
   Instagram, TikTok) – връща 403 disallowed_useragent. Там вместо бутона
   казваме как да се отвори страницата в истинския браузър. */

const IN_APP = /FBAN|FBAV|FB_IAB|Instagram|musical_ly|BytedanceWebview|; wv\)/i;

const ua = () => (typeof navigator === 'undefined' ? '' : navigator.userAgent || '');

// Android отваря intent:// адреса в браузъра по подразбиране.
const browserLink = () =>
  `intent://${window.location.host}${window.location.pathname}${window.location.search}#Intent;scheme=https;end`;

const MESSAGES = {
  'auth/account-exists-with-different-credential':
    'Този имейл вече има регистрация с парола – за него входът е с имейл и парола.',
  'auth/popup-blocked':
    'Браузърът спря прозореца за вход с Google. Нужно е да се разрешат изскачащите прозорци.',
};

// Затворен прозорец или второ натискане – не е грешка.
const SILENT = ['auth/popup-closed-by-user', 'auth/cancelled-popup-request', 'auth/user-cancelled'];

const GoogleLogo = () => (
  <svg viewBox="0 0 48 48" width="18" height="18" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
  </svg>
);

export const GoogleSignIn = ({ onSignedIn }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  if (IN_APP.test(ua())) {
    return (
      <div className="gsi">
        <p className="gsi-note">
          Вход с Google не работи в браузъра на Facebook, Instagram и TikTok. За него страницата
          трябва да е отворена в Chrome или Safari (меню ⋯ → „Отвори в браузър“).
        </p>
        {/Android/i.test(ua()) && (
          <a className="gsi-btn" href={browserLink()}>Отвори в браузъра</a>
        )}
      </div>
    );
  }

  const onClick = async () => {
    setError(null);
    setBusy(true);
    const provider = new firebase.auth.GoogleAuthProvider();
    provider.setCustomParameters({ prompt: 'select_account' });
    auth.languageCode = 'bg';
    try {
      const { user } = await auth.signInWithPopup(provider);
      // Като при регистрацията: хедърът взима името оттук.
      if (user.displayName) localStorage.setItem('username', user.displayName);
      setBusy(false);
      onSignedIn?.();
    } catch (err) {
      setBusy(false);
      if (!SILENT.includes(err.code)) setError(MESSAGES[err.code] || 'Входът с Google не успя.');
    }
  };

  return (
    <div className="gsi">
      <button type="button" className="gsi-btn" onClick={onClick} disabled={busy}>
        <GoogleLogo />
        Вход с Google
      </button>
      {error && <p className="gsi-error" role="alert">{error}</p>}
    </div>
  );
};
